import { type RemoveHookResponse, mutationRemove } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useExternalLinkCache } from './cache'
import { type ExternalLinkRemoveInput, type ExternalLinkRemoveSuccess, type ExternalLinkId } from '@terros/common'

export type RemoveExternalLinkInput = {
  externalLinkId: ExternalLinkId
  archive?: boolean
}

export function useRemoveExternalLink(): RemoveHookResponse<RemoveExternalLinkInput> {
  const mutation = useTantalimMutation<ExternalLinkRemoveInput, ExternalLinkRemoveSuccess>({
    url: '/externalLink/remove',
  })
  const cache = useExternalLinkCache()
  async function remove(removeData: RemoveExternalLinkInput): Promise<void> {
    await mutation.mutateAsync(removeData)
    cache.removeItem(removeData.externalLinkId)
  }

  return mutationRemove(mutation, remove)
}
